<template>
  <main class="omnistock omni-card-body">
    <slot />
  </main>
</template>

<style lang="scss">
.omnistock {
    &.omni-card-body {
      padding: 0 1rem;
    }
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "OmniCardBody",
});
</script>
